<template>
	<div class="header">
		<div class="container clearfix">
			<div class="logo-wrap">
				<a href="/" class="logo">
					<i class="iconfont icon-shiliangzhinengduixiang float-left"></i>
				</a>
				<span class="line"></span>
				<span class="logo-text">社会美术水平考级管理系统</span>
			</div>
			<div class="nav">
				<a class="item" href="https://mskj.caa.edu.cn">官网首页</a>
				<span class="line"></span>
				<router-link class="item" to="/room-query">考场查询</router-link>
				<span class="line"></span>
				<router-link class="item" to="/certificate-query">证书查询</router-link>
				<span class="line"></span>
				<router-link class="item" to="/inventory-query">监考证查询</router-link>

				<div style="display:inline-block" v-if="$store.getters.status">
					<span class="line"></span>
					<router-link class="item" to="/home">个人中心</router-link>

					<!-- <span class="line"></span>
					<router-link class="item" to="/sign-up">在线报名</router-link> -->

					<span class="line"></span>
					<a class="item" href="javascript:;" @click="quit">安全退出</a>
				</div>
				<div style="display:inline-block" v-else>
					<span class="line"></span>
					<router-link class="item" to="/login">登录</router-link>
					<!-- <span class="line"></span>
					<a class="item" href="javascript:;">注册</a>-->
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	methods: {
		quit() {
			this.$store.dispatch('logout').then(() => {
				location.reload();
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';
.header {
	height: 80px;
	line-height: 80px;
	background: $--color-red;
	overflow: hidden;
	.logo-wrap {
		float: left;
		.logo {
			.iconfont {
				color: #fff;
				font-size: 34px;
				vertical-align: middle;
			}
		}
		.line {
			height: 40px;
			display: inline-block;
			width: 1px;
			margin: 0 20px;
			background: #fff;
			vertical-align: middle;
		}
		.logo-text {
			color: #fff;
			line-height: 80px;
			font-size: 18px;
			letter-spacing: 1.5px;
			vertical-align: middle;
		}
	}
	.nav {
		float: right;
		.line {
			height: 16px;
			display: inline-block;
			width: 1px;
			margin: 0 16px;
			background: #fff;
			vertical-align: middle;
		}
		.item {
			color: #fff;
			vertical-align: middle;
			transition: color 0.3s;
			&:hover {
				color: #000;
			}
		}
	}
}
@media screen and (max-width: 768px) {
	.header {
		height: 2.4rem;
		line-height: 2.4rem;
		.logo-wrap {
			float: left;
			.logo {
				.iconfont {
					color: #fff;
					font-size: 1rem;
					vertical-align: middle;
				}
			}
			.line {
				height: 1rem;
			}
			.logo-text {
				color: #fff;
				line-height: 2.4rem;
				font-size: 0.6rem;
				letter-spacing: 1.5px;
				vertical-align: middle;
			}
		}
		.nav {
			display: none;
			.line {
				height: 16px;
				display: inline-block;
				width: 1px;
				margin: 0 16px;
				background: #fff;
				vertical-align: middle;
			}
			.item {
				color: #fff;
				vertical-align: middle;
				transition: color 0.3s;
				&:hover {
					color: #000;
				}
			}
		}
	}
}
</style>
